import React, { Component } from "react";
import TextControl from "../forms/controls/TextControl";
import CityControl from "../forms/controls/CityControl";
import CheckboxControl from "../forms/controls/CheckboxControl";
import InnerControl from "../forms/controls/InnerControl";
import AdvanceSearchControl from "./AdvanceSearchControl";
import StateControl from "../forms/controls/StateControl";
import GlbControl from "../forms/controls/GlbControl";
import DobControl from "../forms/controls/DobControl";
import PhoneControl from "../forms/controls/PhoneControl";
import SsnControl from "../forms/controls/SsnControl";
import SlideControl from "../forms/controls/SlideControl";
import RangeControl from "../forms/controls/RangeControl";
import DppaControl from "../forms/controls/DppaControl";
import MultiphoneControl from "../forms/controls/MultiphoneControl";

class SearchControls extends Component {
  render() {
    let controls = [];
    let rangeControls = [];
    let innerContols = null;
    const { isLeftSearch } = this.props;
    if (
      this.props.formControls !== undefined &&
      this.props.formControls.length > 0
    ) {
      controls = this.props.formControls.map((control) => {
        if (innerContols !== null) {
          if (control.FieldType === "/adv") {
            innerContols.push(
              <div key={`ctl_${control.SearchFieldsOnFormId}`} />
            );
            const con = (
              <AdvanceSearchControl
                key={`advance_cont_${control.SearchFieldsOnFormId}`}
                formControls={innerContols}
                errors={this.props.errors}
                notifyChangeToForm={this.props.notifyChangeToForm}
                defaultFormData={this.props.defaultFormData}
                reportId={this.props.reportId}
                isLeftSearch={isLeftSearch}
              />
            );
            innerContols = null;
            return con;
          }
          innerContols.push(control);
        } else {
          if (control.FieldType === "txt" || control.FieldType === "email") {
            return (
              <TextControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData[control.FieldName]}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "phone") {
            return (
              <PhoneControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData[control.FieldName]}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "multi") {
            return (
              <MultiphoneControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData[control.FieldName]}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "ssn") {
            return (
              <SsnControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData[control.FieldName]}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "state") {
            return (
              <StateControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                handleStateSelect={this.handleStateSelect}
                errors={this.props.errors}
                defaultData={
                  this.props.defaultFormData[control.FieldName]
                    ? this.props.defaultFormData[control.FieldName]
                    : "-1"
                }
                firstErrorFieldName={this.props.firstErrorFieldName}
                reportId={this.props.reportId}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "city") {
            return (
              <CityControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                stateCode={this.props.defaultFormData.state}
                defaultData={
                  this.props.defaultFormData[control.FieldName]
                    ? this.props.defaultFormData[control.FieldName]
                    : "-1"
                }
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "dppa") {
            return (
              <DppaControl
                key={control.SearchFieldsOnFormId}
                control={control}
                stateCode={this.props.defaultFormData.state}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData[control.FieldName]}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "zip") {
            return (
              <TextControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData[control.FieldName]}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "chk") {
            return (
              <CheckboxControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData[control.FieldName]}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "slide") {
            return (
              <SlideControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData[control.FieldName]}
                hideControl={
                  this.props.defaultFormData[`hide_${control.FieldName}`]
                }
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (
            control.FieldType === "glb" ||
            control.FieldType === "glbln"
          ) {
            return (
              <GlbControl
                key={control.SearchFieldsOnFormId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "dob") {
            return (
              <DobControl
                key={control.SearchFieldsOnFormId}
                control={control}
                handleDobSelect={this.handleDobSelect}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultData={this.props.defaultFormData}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.FieldType === "adv") {
            innerContols = [];
          } else if (control.FieldType === "from") {
            rangeControls = [];
            rangeControls.push(control);
          } else if (control.FieldType === "to") {
            rangeControls.push(control);
            return (
              <RangeControl
                key={control.SearchFieldsOnFormId}
                controls={rangeControls}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                defaultFormData={this.props.defaultFormData}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          } else if (control.controlType === "inner") {
            return (
              <InnerControl
                key={control.controlId}
                control={control}
                notifyChangeToForm={this.props.notifyChangeToForm}
                errors={this.props.errors}
                firstErrorFieldName={this.props.firstErrorFieldName}
                isLeftSearch={isLeftSearch}
              />
            );
          }
          return <div key={`ctl_${control.SearchFieldsOnFormId}`} />;
        }
        return null;
      });
    }

    return controls;
  }
}

export default SearchControls;



// WEBPACK FOOTER //
// ./src/components/searches/SearchControls.js